import { RichTextBlock } from 'prismic-reactjs'

/**
 * Takes content from CMS and replaces placeholders {earned}, {remaining} and
 * {max} and replaces them with real data.
 * @returns populated content.
 */
const populateData = (
  raw: RichTextBlock[],
  earned: number | undefined,
  remaining: number | undefined,
  max: number | undefined,
) => {
  return raw.map(i => {
    const len = i?.text?.length || 0
    const text = i?.text
      ?.replace('{earned}', `${earned || 0}`)
      .replace('{max}', `${max || 0}`)
      .replace('{remaining}', `${remaining || 0}`)

    const nextLen = text?.length || 0
    const diff = nextLen - len

    return {
      ...i,
      spans: i.spans?.map(span => ({ ...span, end: span.end + diff })),
      text,
    }
  })
}

export default populateData
